import { useEffect } from "react";

/**
 * Site-level INP optimization: warm interaction-only chunks (header video
 * modal, top-banner giveaway modal, auto popup) on the FIRST real user
 * intent signal: pointerdown, touchstart, or keydown. We deliberately do
 * NOT listen for pointermove or scroll because Lighthouse's emulator fires
 * a synthetic pointermove when positioning its cursor, and in-page smooth
 * scrolling (e.g. category tabs) can fire scroll before any user intent.
 * Both put the modal chunks back on the LCP critical-request chain.
 */
const IdlePrefetcher = () => {
  useEffect(() => {
    let done = false;
    const prefetch = () => {
      if (done) return;
      done = true;
      cleanup();
      void import("@/components/VideoModal");
      void import("@/components/GiveawayModal");
      void import("@/components/OffroadInsurancePopup");
    };

    const events: Array<keyof WindowEventMap> = [
      "pointerdown",
      "touchstart",
      "keydown",
    ];
    const opts: AddEventListenerOptions = { once: true, passive: true, capture: true };

    const cleanup = () => {
      events.forEach((e) => window.removeEventListener(e, prefetch, true));
    };

    events.forEach((e) => window.addEventListener(e, prefetch, opts));

    return cleanup;
  }, []);

  return null;
};

export default IdlePrefetcher;